import Vue from 'vue';

/**
 * Legacy values are used )that is why  2 sizes only).
 * If width is more than 1150 - desktop otherwise - mobile
 */
const DESKTOP_WIDTH = 1150;

const screen = Vue.observable({
  isMobile: false,
  isDesktop: false,
});

function resetScreen() {
  screen.isMobile = false;
  screen.isDesktop = false;
}

function updateActiveScreen(width) {
  if (width <= DESKTOP_WIDTH && !screen.isMobile) {
    resetScreen();
    screen.isMobile = true;
  } else if (width > DESKTOP_WIDTH && !screen.isDesktop) {
    resetScreen();
    screen.isDesktop = true;
  }
}

function handleOnScreenResize(event) {
  updateActiveScreen(event.target.innerWidth);
}

const screenSizeProvider = {
  provide() {
    return {
      screen,
    };
  },
  mounted() {
    updateActiveScreen(window.innerWidth);
    window.addEventListener('resize', handleOnScreenResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', handleOnScreenResize);
  },
};

export default screenSizeProvider;
